import { render, staticRenderFns } from "./b-order-detail.vue?vue&type=template&id=73f5bbb3&scoped=true&"
import script from "./b-order-detail.vue?vue&type=script&lang=js&"
export * from "./b-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./b-order-detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./b-order-detail.vue?vue&type=style&index=1&id=73f5bbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5bbb3",
  null
  
)

export default component.exports